/**
 * TradeStation new-account offer — single URL for all product UI links to TradeStation signup.
 * Promo code may be overridden via REACT_APP_TRADESTATION_PROMO_CODE.
 */

const trimOrEmpty = (v) => (typeof v === 'string' ? v.trim() : '');

/** All UI links to open a TradeStation account use this URL. */
export const TRADESTATION_AOP_URL =
  'https://getstarted2.tradestation.com/intro?offer=PTDRAGRZ';

export const TRADESTATION_PROMO_CODE =
  trimOrEmpty(process.env.REACT_APP_TRADESTATION_PROMO_CODE) || 'PTDRAGRZ';

/** Small label above headline (strip uses uppercase styling in UI). */
export const TRADESTATION_PROMO_EYEBROW = 'Broker reward';

/** Text before inline TradeStation logo in promo headline. */
export const TRADESTATION_PROMO_HEADLINE_BEFORE = 'Get $100 when you open a ';

/** Text after inline TradeStation logo in promo headline. */
export const TRADESTATION_PROMO_HEADLINE_AFTER = ' account and link to PrecisionTrader';

/** Onboarding connect step: same offer without PrecisionTrader cross-link in headline. */
export const TRADESTATION_PROMO_HEADLINE_AFTER_ONBOARDING = ' account';

/** Full headline as plain text (e.g. analytics, docs); UI uses logo between before/after. */
export const TRADESTATION_PROMO_HEADLINE = `${TRADESTATION_PROMO_HEADLINE_BEFORE}TradeStation${TRADESTATION_PROMO_HEADLINE_AFTER}`;

/** AOP link label in promo strip, modal, and landing broker block. */
export const TRADESTATION_PROMO_CTA_LABEL = 'Open account today!';

/** Supported-brokers table row — section banner carries the full offer. */
export const TRADESTATION_PROMO_TABLE_ROW_PREFIX = 'Get $100 when you ';
export const TRADESTATION_PROMO_TABLE_ROW_LINK_LABEL = 'open an account';

/** Disclaimer (leading * is rendered separately in UI). Uses {@link TRADESTATION_PROMO_CODE} (env override). */
export function tradestationPromoOfferFootnote(promoCode = TRADESTATION_PROMO_CODE) {
  return `Click the link above or enter promo code ${promoCode} when you open your TradeStation account. Fund $2,000 or more to qualify.`;
}

/**
 * Homepage footer note: no promo code in text; code is delivered in-app after PrecisionTrader signup.
 * Leading * is rendered separately in UI (see {@link TradeStationHomeSoftPromoFooterNote}).
 */
export const TRADESTATION_PROMO_HOME_SOFT_FOOTER_BODY =
  'TradeStation funded-account offers are subject to TradeStation program terms and funding requirements. Your referral promo code is provided in PrecisionTrader after you open your account.';

/** Broker mark in `public/images/` (used in promos and onboarding). */
export function tradestationBrokerLogoUrl() {
  const base = trimOrEmpty(process.env.PUBLIC_URL);
  return `${base}/images/broker-tradestation-logo.png`;
}
